import React from 'react';

function timeAgo(iso) {
  if (!iso) return '';
  const diffMs = Date.now() - new Date(iso).getTime();
  const mins = Math.round(diffMs / 60000);
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.round(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  return `${Math.round(hours / 24)}d ago`;
}

export default function NewsCard({ article, insight }) {
  return (
    <a href={article.url} target="_blank" rel="noopener noreferrer" className="news-card">
      <div className="news-card-header">
        <span className="news-source">{article.source}</span>
        <span className="news-time">{timeAgo(article.publishedAt)}</span>
        {insight?.sentiment && <span className={`sentiment-pill ${insight.sentiment.toLowerCase()}`}>{insight.sentiment}</span>}
      </div>
      <p className="news-headline">{article.headline}</p>
      {insight?.whyItMatters && <p className="news-why">{insight.whyItMatters}</p>}
    </a>
  );
}
